<ng-content></ng-content>
@if (sortDirection === 'asc') {
    <i class="fa fa-chevron-up"></i>
}
@if (sortDirection === 'desc') {
    <i class="fa fa-chevron-down"></i>
}
